import { useState, useEffect } from 'react'
import { db } from '../../../../utils/firebase'

// Per-round tee-time editor for the enquiry Quotes tab (slice 6). Only rendered
// when `editable` is passed, so the read-only consumers (client/my-quotes
// pages) are completely unaffected.
import QuoteTeeTimesEditor from '../../../../containers/enquiry/_components/quote-tee-times-editor'
import { PencilIcon } from '../../../../utils/svgs-v2'

// Display a reference as a link for viewing a quote document.
//
// On the enquiry Quotes tab the row is `editable`: it gains an edit affordance
// that opens the per-round tee-time editor. Saving there regenerates this
// package's PDF and prompts a resend (handled in QuoteTeeTimesEditor). All the
// editing props default to falsy so the read-only consumers stay as they were.
export default function QuoteDocument({ quoteID, quotePackage, editable = false, quote, clientName, clientEmail, agent }) {
    const [link, setLink] = useState('')
    const [editing, setEditing] = useState(false)

    // Pull the link for the document on load
    useEffect(() => {
        db.doc(`quotes/${quoteID}/documents/${quotePackage.reference}`)
            .get().then((quoteDoc) => {
                setLink(quoteDoc.data()?.pdf_url)
            })
    }, [quoteID, quotePackage])

    // Read-only consumers (client account + my-quotes pages) render exactly as
    // before - a bare inline link - so their existing horizontal layout
    // (`.client-quote-references a { display: inline-block }`) is preserved. The
    // block wrapper + edit affordance only applies on the editable enquiry tab.
    if (!editable) {
        return (
            <a target='_blank' rel='noreferrer' href={link}>{quotePackage.reference} (£{quotePackage.final_cost}pp)</a>
        )
    }

    return (
        <div className='quote-document'>
            <div className='quote-document-row'>
                <a target='_blank' rel='noreferrer' href={link}>{quotePackage.reference} (£{quotePackage.final_cost}pp)</a>

                <div
                    className='quote-document-edit'
                    title='Edit tee times'
                    onClick={() => setEditing((current) => !current)}>
                    <PencilIcon />
                </div>
            </div>

            {editing && (
                <QuoteTeeTimesEditor
                    quote={quote}
                    quotePackage={quotePackage}
                    clientName={clientName}
                    clientEmail={clientEmail}
                    agent={agent}
                    onClose={() => setEditing(false)}
                    onRegenerated={(reference, url) => setLink(url)}
                />
            )}
        </div>
    )
}
